
import { IViewColumnBooleanIconSettings } from "@/utils/views/view-column";
import Vue from "vue";
import { TranslateResult } from "vue-i18n";
import AppColorPicker from "@/components/ColorPicker.vue";

export default Vue.extend({
	data(){
		return {
			isOpened: false
		};
	},
	props: {
		column: {
			type: Object as ()=>IViewColumnBooleanIconSettings,
			required: true
		}
	},
	computed: {
		toggleText():TranslateResult{
			if (this.isOpened) {
				return this.$ct("close-advanced-options");
			}
			return this.$ct("open-advanced-options");
		}
	},
	components: {
		AppColorPicker
	},
	i18nEx: {
		componentPrefix: "components.view-editor"
	}
});
